import { useIntl  } from 'react-intl';
import { notification } from 'antd';
import axios from 'axios';
import Cookies from 'universal-cookie';
import {calculateSHA256} from '../utils/utils'
import { API_TOKEN} from '../utils/constants';

import LoginPage from '../controls/LoginPage';

const LoginPane = (props) => {  

    const intl = useIntl();

    async function onSubmit(credentials) {
        credentials.password = await calculateSHA256(credentials.password);
        axios.post("/login", credentials)
        .then(response => {
            const cookies = new Cookies();
            cookies.set(API_TOKEN, response.data, {maxAge: 60 * 60 * 24 * 30 * 2});

            window.location.href = "/";
        })
        .catch(err => {
          notification['error']({
            message: intl.formatMessage({id: 'Error'}),
            description: err.message,
            duration: 0
          });
        });        
      };
    
    return (
        <div>
            <LoginPage onSubmit = {(credentials) => onSubmit(credentials)}/>
        </div>
    );   
}
  
export default LoginPane;